import computeTagName from '../../../../utils/computeTagName';
import computeClassName from '../../../../utils/computeClassName';
import handleEventClick from "../../../../utils/handleEventClick";

const constants = Object.freeze({
  CLASSNAME_BASE: 'text-cc-body-large',
  TAG_DEFAULT: 'section'
});

const propsDefaults = Object.freeze({
  tag: constants.TAG_DEFAULT
});

function openPartnerWebSite(url) {
  if (url !== '') {
    window.open(url, '_blank','noreferrer');
  }
}

export default function PartnerNameAndAddress({
    partnerName,
    partnerAddressLine1,
    partnerAddressLine2 = '',
    partnerAddressLine3 = '',
    partnerCity,
    partnerStateOrRegion,
    partnerZipOrPostalCode,
    partnerCountry,
    partnerWebSiteAddress,
    partnerPhoneNumber,
    className,
    tag = propsDefaults.tag,
  }) {
  const ComputedComponentTag = computeTagName(tag, constants.TAG_DEFAULT);
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  const cityZipRegionText = `${!!partnerCity?partnerCity+', ':''}${!!partnerZipOrPostalCode?partnerZipOrPostalCode:''} ${!!partnerStateOrRegion?partnerStateOrRegion:''}`.trim();

  let correctedPartnerWebSiteAddress = partnerWebSiteAddress;
  if (partnerWebSiteAddress !== '') {
    if (!partnerWebSiteAddress.toLowerCase().startsWith('http://') &&
      !partnerWebSiteAddress.toLowerCase().startsWith('https://')) {
      correctedPartnerWebSiteAddress = `https://${partnerWebSiteAddress}`;
    }
  }

  const computedWebSiteAddressClickFn = handleEventClick(openPartnerWebSite, correctedPartnerWebSiteAddress);


  return (
    <ComputedComponentTag className={computedClassName}>
      <h3 className="text-cc-200 sm:text-cc-300 mb-2">{partnerName}</h3>
      <div className="text-cc-body-medium sm:text-cc-body-large text-cc-secondary-contrast mb-4">
        <p>{partnerAddressLine1}</p>
        { !!partnerAddressLine2 && !!partnerAddressLine2.length &&
        <p>{partnerAddressLine2}</p>
        }
        { !!partnerAddressLine3 && !!partnerAddressLine3.length &&
        <p>{partnerAddressLine3}</p>
        }
        <p>{cityZipRegionText}</p>
        <p>{partnerCountry}</p>
      </div>
      {
        ((partnerWebSiteAddress !== '') || (partnerPhoneNumber !== '')) &&
        <div>
          {
            partnerWebSiteAddress !== '' &&
            <p><a className="text-cc-link" target="_blank" href={correctedPartnerWebSiteAddress} rel="noreferrer" onClick={computedWebSiteAddressClickFn}>{partnerWebSiteAddress}</a></p>
          }
          {
            (partnerPhoneNumber !== '' && (partnerPhoneNumber.length > 4)) &&
            <p><a className="text-cc-link" target="_blank" href={`tel:${partnerPhoneNumber}`} rel="noreferrer">{partnerPhoneNumber}</a></p>
          }
        </div>
      }
    </ComputedComponentTag>
  );
}

